import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UpdateUserActiveState } from "./active-status.reducer";

export const selectActiveStatus = "activeStatus";
export const selectActiveStatusState =
  createFeatureSelector<UpdateUserActiveState>(selectActiveStatus);

export const selectActiveStatusUpdated = createSelector(
  selectActiveStatusState,
  (state) => state.data
);

export const selectActiveStatusLoading = createSelector(
  selectActiveStatusState,
  (state) => state.isLoading
);

export const selectActiveStatuseError = createSelector(
  selectActiveStatusState,
  (state) => state.error
);
